import * as angular from "angular";

export class LogsService {
    private root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.root = "/v2/logs";
    }

    all(params: {
        offset: number;
        limit: number;
        filters: object;
    }): Promise<object> {
        return this.$http.get(this.root + "/all", { params: params });
    }

    user(data: any): Promise<object> {
        return this.$http.get(this.root + "/user/" + data.uid);
    }
}

angular.module("vcServices").service("LogsService", LogsService);
